import {
  fetch,
  extractHubURL,
  normalize
} from '../../utils/dataAccess';
import {success as deleteSuccess} from "./delete";

export function error(error) {
  return { type: 'INVITATION_INTERVIEW_STATUS_SHOW_ERROR', error };
}

export function loading(loading) {
  return { type: 'INVITATION_INTERVIEW_STATUS_SHOW_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'INVITATION_INTERVIEW_STATUS_SHOW_SUCCESS', retrieved };
}

export function retrieve(id) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        retrieved = normalize(retrieved);

        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'INVITATION_INTERVIEW_STATUS_SHOW_RESET' });
    dispatch(error(null));
    dispatch(loading(false));
    dispatch(deleteSuccess(null));
  };
}
